import styled from 'styled-components';
import { TableCell } from '../../OrionOnboardingStyles';

export const Wrapper = styled.div`
  margin: 0 auto;
  padding: 75px 0;
  width: 100%;
  max-width: 600px;
`;

export const OrionAssetClassCell = styled(TableCell)`
  width: 50%;
  display: flex;
`;

export const AdvizrAssetClassCell = styled(TableCell)`
  width: 50%;
`;

export const OrdinalText = styled.span`
  margin-right: 20px;
`;
